export default __webpack_public_path__ + "static/knowledge-25d906c05ddedf876ec9cd67eaeb7d75.png";